export enum Action {
  CAN_REGISTER_CONTINUE_ADDRESS = 'CAN_REGISTER_CONTINUE_ADDRESS',
  CAN_REGISTER_CONTINUE_CUSTOMER_ID = 'CAN_REGISTER_CONTINUE_CUSTOMER_ID',
  BACK = 'BACK',
  CUSTOMER_SET_CREDENTIALS = 'CUSTOMER_SET_CREDENTIALS',
  CUSTOMER_SET_EMAIL = 'CUSTOMER_SET_EMAIL',
  CUSTOMER_SET_PASSWORD = 'CUSTOMER_SET_PASSWORD',
  CUSTOMER_REGISTERED = 'CUSTOMER_REGISTERED',
}

export enum State {
  CAN_REGISTER_ADDRESS = 'CAN_REGISTER_ADDRESS',
  CAN_REGISTER_CUSTOMER_ID = 'CAN_REGISTER_CUSTOMER_ID',
  VALIDATING_CUSTOMER = 'VALIDATING_CUSTOMER',
  REGISTER_PERSON = 'REGISTER_PERSON',
  REGISTER_ORG_EMAIL = 'REGISTER_ORG_EMAIL',
  REGISTER_ORG_PASSWORD = 'REGISTER_ORG_PASSWORD',
  SETTING_NEW_CREDENTIALS = 'SETTING_NEW_CREDENTIALS',
  REGISTER_SUCCESS = 'REGISTER_SUCCESS',
}

export enum Service {
  CAN_REGISTER_WITH_CUSTOMER_ID = 'CAN_REGISTER_WITH_CUSTOMER_ID',
  REGISTER_WITH_CUSTOMER_ID = 'REGISTER_WITH_CUSTOMER_ID',
}

export enum PageViews {
  CAN_REGISTER_ADDRESS = 'adres',
  CAN_REGISTER_CUSTOMER_ID = 'klantnummer',
  REGISTER_PERSON = 'email-wachtwoord',
  REGISTER_ORG_EMAIL = 'email-mkb',
  REGISTER_ORG_PASSWORD = 'wachtwoord-mkb',
  REGISTER_SUCCESS = 'bevestiging',
}

export enum FunnelSteps {
  CAN_REGISTER_ADDRESS = 'Adres',
  CAN_REGISTER_CUSTOMER_ID = 'Klantnummer',
  REGISTER_PERSON = 'Inloggegevens',
  REGISTER_ORG_EMAIL = 'MKB Inloggegevens email',
  REGISTER_ORG_PASSWORD = 'MKB Inloggegevens password',
  REGISTER_SUCCESS = 'Complete',
}

export const flowVariants = ['RegistrationAccountCreate', 'RegistrationAccountReset'] as const;
